import React from 'react'
import Top_heading from './component/Top_heading'
import ServicesCounter from './services-component/ServicesCounter'
import CaseStudy from './services-component/CaseStudy'
import Faq_s from './services-component/Faq-web-dev'
import ContactArea from './services-component/ContactArea'
import Main_Heading from './services-component/Main_Heading'
import Web_Dev_Services from './services-component/Web_Dev_Services'
import Web_Dev_Ser_UAE from './services-component/Web_Dev_Ser_UAE'
import Websites from './services-component/Websites'
import Web_Tech_Logos from './services-component/Web_Tech_Logos'
import { Helmet } from "react-helmet-async";

export default function Website_Services() {
  return (
    <>

    <Helmet>
  {/* ✅ Meta Title */}
  <title>
    Website Development Dubai & India | Developers – RajDigi
  </title>

  {/* ✅ Meta Description */}
  <meta
    name="description"
    content="Expert website developers in Dubai & India. Custom web development, responsive design & seamless user experience. Build your digital presence with us."
  />

  {/* ✅ Meta Keywords */}
  <meta
    name="keywords"
    content="website development Dubai, website developers India"
  />
</Helmet>

      <Top_heading Heading="WEBSITE DEVELOPMENT" para="Build your digital presence with expert website development services tailored to your business goals. "/>

      <Main_Heading SideHeading="Website Development for Business Growth"
        ButtonText="Share Your Project" 
        para1="In today’s competitive digital world, transitioning from traditional brick-and-mortar stores to a strong online presence is essential. Partnering with Raj Digital Marketing for professional web development services is the best way to ensure your brand stands out online."
        para2="Our experienced team specializes in both front-end and back-end development, covering everything from intuitive UX/UI design to robust database technologies. Whether you’re a startup or an established enterprise, our comprehensive web solutions are tailored to meet your needs."
        para3="Get in touch with our experts today to create scalable, user-friendly web designs and development solutions that drive growth at affordable rates." />

      
      <Websites/>

      <ServicesCounter/>

      <Web_Dev_Services
      
      head1="Complete Website Development Solutions"
      para1="Stay ahead in the digital space with fast, secure, and interactive websites tailored to your business needs."

      head2="eCommerce Web Development Services"
      para2="Let our experts build a modern, high performing online store that delivers a smooth and engaging shopping experience for your customers."
      
      head3="Web App Development Services"
      para3="Elevate your digital presence with secure, high performing, and scalable web applications designed to accelerate your business growth."

      head4="
Custom CMS Solutions
"
      para4="We deliver open-source CMS development tailored to your brand whether it's WordPress, Joomla, Drupal, or Magento—to help you manage and scale your digital content with ease."

      head5="Website Design & Redesign"
      para5="Boost efficiency and streamline workflows with a high-performance website tailored by our expert web development team—whether you're building from scratch or revamping an existing site."

      head6="Web Portal Development"
      para6="Build a powerful, user-friendly web portal tailored for B2B or B2C needs designed to boost engagement, expand your reach, and unlock new revenue opportunities."
      /> 

      {/* <Web_Dev_Ser_UAE/> */}

      <Web_Tech_Logos/>

      {/* <CaseStudy/> */}

      <Faq_s/>

      <ContactArea/>
    </>
  )
}
